import toString from 'lodash/toString'

export const castToString = (val: any): string => {
  return toString(val)
}